import { render } from "./PlayerCard.vue?vue&type=template&id=d2ac793e"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__